const FormResources = {

    form_data:{
        building_id:        '',
        level_id:           '',
        name:               '',
        frequency:          0,
        closed:             false,
        daily_shift_1:      false,
        daily_shift_2:      false,
        daily_shift_3:      false,
        policing_shift_1:   false,
        policing_shift_2:   false,
        policing_shift_3:   false,
        project_shift_1:    false,
        project_shift_2:    false,
        project_shift_3:    false,
        description:        '',
        abbreviation:       '',
        sq_footage:         '',
    },

    form_format:[
        {
            css_class:  'col-md-6',
            type:       'select',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Building:',
            model_name: 'building_id',
            ref:        'building_id_input',
            ref_alt:    'building_id_input_alt',
            required:   true,
        },
        {
            css_class:  'col-md-6',
            type:       'select',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Level:',
            model_name: 'level_id',
            ref:        'level_id_input',
            ref_alt:    'level_id_input_alt',
            required:   true,
        },
        {
            css_class:  'col-md-6',
            type:       'text',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       'Name:',
            model_name: 'name',
            ref:        'name_input',
            ref_alt:    'name_input_alt',
            required:   true,
        },
        {
            css_class:  'col-md-6',
            type:       'text',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       'Abbreviation:',
            model_name: 'abbreviation',
            ref:        'abbreviation_input',
            ref_alt:    'abbreviation_input_alt',
            required:   true,
        },
        {
            css_class:  'col-md-6',
            type:       'number',
            maxlength:  7,
            disabled:   false,
            step:       '',
            name:       'Frequency:',
            model_name: 'frequency',
            ref:        'frequency_input',
            ref_alt:    'frequency_input_alt',
            required:   true,
        },
        {
            css_class:  'col-md-2',
            type:       'checkbox',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Closed:',
            model_name: 'closed',
            ref:        'closed_input',
            ref_alt:    'closed_input_alt',
            required:   false,
        },
        {
            css_class:  'col-md-6',
            type:       'checkbox-plus',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Daily shift:',
            model_name: '',
            ref:        '',
            ref_alt:    '',
            required:   true,
            childs:     [
                {
                    css_class:  'col-md-2',
                    type:       'checkbox',
                    maxlength:  '',
                    disabled:   false,
                    step:       '',
                    name:       '1',
                    model_name: 'daily_shift_1',
                    ref:        'daily_shift_1_input',
                    ref_alt:    'daily_shift_1_input_alt',
                    required:   false,
                },
                {
                    css_class:  'col-md-2',
                    type:       'checkbox',
                    maxlength:  '',
                    disabled:   false,
                    step:       '',
                    name:       '2',
                    model_name: 'daily_shift_2',
                    ref:        'daily_shift_2_input',
                    ref_alt:    'daily_shift_2_input_alt',
                    required:   false,
                },
                {
                    css_class:  'col-md-2',
                    type:       'checkbox',
                    maxlength:  '',
                    disabled:   false,
                    step:       '',
                    name:       '3',
                    model_name: 'daily_shift_3',
                    ref:        'daily_shift_3_input',
                    ref_alt:    'daily_shift_3_input_alt',
                    required:   false,
                },
            ]
        },
        {
            css_class:  'col-md-6',
            type:       'checkbox-plus',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Policing shift:',
            model_name: '',
            ref:        '',
            ref_alt:    '',
            required:   true,
            childs:     [
                {
                    css_class:  'col-md-2',
                    type:       'checkbox',
                    maxlength:  '',
                    disabled:   false,
                    step:       '',
                    name:       '1',
                    model_name: 'policing_shift_1',
                    ref:        'policing_shift_1_input',
                    ref_alt:    'policing_shift_1_input_alt',
                    required:   false,
                },
                {
                    css_class:  'col-md-2',
                    type:       'checkbox',
                    maxlength:  '',
                    disabled:   false,
                    step:       '',
                    name:       '2',
                    model_name: 'policing_shift_2',
                    ref:        'policing_shift_2_input',
                    ref_alt:    'policing_shift_2_input_alt',
                    required:   false,
                },
                {
                    css_class:  'col-md-2',
                    type:       'checkbox',
                    maxlength:  '',
                    disabled:   false,
                    step:       '',
                    name:       '3',
                    model_name: 'policing_shift_3',
                    ref:        'policing_shift_3_input',
                    ref_alt:    'policing_shift_3_input_alt',
                    required:   false,
                },
            ]
        },
        {
            css_class:  'col-md-6',
            type:       'checkbox-plus',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Project shift:',
            model_name: '',
            ref:        '',
            ref_alt:    '',
            required:   true,
            childs:     [
                {
                    css_class:  'col-md-2',
                    type:       'checkbox',
                    maxlength:  '',
                    disabled:   false,
                    step:       '',
                    name:       '1',
                    model_name: 'project_shift_1',
                    ref:        'project_shift_1_input',
                    ref_alt:    'project_shift_1_input_alt',
                    required:   false,
                },
                {
                    css_class:  'col-md-2',
                    type:       'checkbox',
                    maxlength:  '',
                    disabled:   false,
                    step:       '',
                    name:       '2',
                    model_name: 'project_shift_2',
                    ref:        'project_shift_2_input',
                    ref_alt:    'project_shift_2_input_alt',
                    required:   false,
                },
                {
                    css_class:  'col-md-2',
                    type:       'checkbox',
                    maxlength:  '',
                    disabled:   false,
                    step:       '',
                    name:       '3',
                    model_name: 'project_shift_3',
                    ref:        'project_shift_3_input',
                    ref_alt:    'project_shift_3_input_alt',
                    required:   false,
                },
            ],
        },
        {
            css_class:  'col-md-6',
            type:       'number',
            maxlength:  365,
            disabled:   true,
            step:       '',
            name:       'Sq. Footage:',
            model_name: 'sq_footage',
            ref:        'sq_footage_input',
            ref_alt:    'sq_footage_input_alt',
            required:   false,
        },
    ],

    form_data_status: {
        closed:             false,
    },

    form_format_status: [
        {
            css_class:  'col-md-12',
            type:       'checkbox-plus',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Daily shift:',
            model_name: '',
            ref:        '',
            ref_alt:    '',
            required:   true,
            childs:     [
                {
                    css_class:  'col-md-2',
                    type:       'checkbox',
                    maxlength:  '',
                    disabled:   false,
                    step:       '',
                    name:       '1',
                    model_name: 'daily_shift_1',
                    ref:        'daily_shift_1_input',
                    ref_alt:    'daily_shift_1_input_alt',
                    required:   false,
                },
                {
                    css_class:  'col-md-2',
                    type:       'checkbox',
                    maxlength:  '',
                    disabled:   false,
                    step:       '',
                    name:       '2',
                    model_name: 'daily_shift_2',
                    ref:        'daily_shift_2_input',
                    ref_alt:    'daily_shift_2_input_alt',
                    required:   false,
                },
                {
                    css_class:  'col-md-2',
                    type:       'checkbox',
                    maxlength:  '',
                    disabled:   false,
                    step:       '',
                    name:       '3',
                    model_name: 'daily_shift_3',
                    ref:        'daily_shift_3_input',
                    ref_alt:    'daily_shift_3_input_alt',
                    required:   false,
                },
            ]
        },
        {
            css_class:  'col-md-12',
            type:       'checkbox-plus',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Policing shift:',
            model_name: '',
            ref:        '',
            ref_alt:    '',
            required:   true,
            childs:     [
                {
                    css_class:  'col-md-2',
                    type:       'checkbox',
                    maxlength:  '',
                    disabled:   false,
                    step:       '',
                    name:       '1',
                    model_name: 'policing_shift_1',
                    ref:        'policing_shift_1_input',
                    ref_alt:    'policing_shift_1_input_alt',
                    required:   false,
                },
                {
                    css_class:  'col-md-2',
                    type:       'checkbox',
                    maxlength:  '',
                    disabled:   false,
                    step:       '',
                    name:       '2',
                    model_name: 'policing_shift_2',
                    ref:        'policing_shift_2_input',
                    ref_alt:    'policing_shift_2_input_alt',
                    required:   false,
                },
                {
                    css_class:  'col-md-2',
                    type:       'checkbox',
                    maxlength:  '',
                    disabled:   false,
                    step:       '',
                    name:       '3',
                    model_name: 'policing_shift_3',
                    ref:        'policing_shift_3_input',
                    ref_alt:    'policing_shift_3_input_alt',
                    required:   false,
                },
            ]
        },
        {
            css_class:  'col-md-12',
            type:       'checkbox-plus',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Project shift:',
            model_name: '',
            ref:        '',
            ref_alt:    '',
            required:   true,
            childs:     [
                {
                    css_class:  'col-md-2',
                    type:       'checkbox',
                    maxlength:  '',
                    disabled:   false,
                    step:       '',
                    name:       '1',
                    model_name: 'project_shift_1',
                    ref:        'project_shift_1_input',
                    ref_alt:    'project_shift_1_input_alt',
                    required:   false,
                },
                {
                    css_class:  'col-md-2',
                    type:       'checkbox',
                    maxlength:  '',
                    disabled:   false,
                    step:       '',
                    name:       '2',
                    model_name: 'project_shift_2',
                    ref:        'project_shift_2_input',
                    ref_alt:    'project_shift_2_input_alt',
                    required:   false,
                },
                {
                    css_class:  'col-md-2',
                    type:       'checkbox',
                    maxlength:  '',
                    disabled:   false,
                    step:       '',
                    name:       '3',
                    model_name: 'project_shift_3',
                    ref:        'project_shift_3_input',
                    ref_alt:    'project_shift_3_input_alt',
                    required:   false,
                },
            ],
        },
        {
            css_class:  'col-md-2',
            type:       'checkbox',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Closed:',
            model_name: 'closed',
            ref:        'closed_input',
            ref_alt:    'closed_input_alt',
            required:   false,
        },
    ]


}

export default FormResources;